import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import MenuHeader from './MenuHeader';
import NavHotel from './NavHotel';
import useApi from '../hooks/useApi';
import CategoryService from '../services/category.service';
import ProductService from '../services/product.service';
import AuthService from '../services/auth.service';
import { useNotifications } from '../context/NotificationProvider';
import DomainService from '../services/domain.service';
import useAuth from '../hooks/useAuth';
import remove from '../assets/images/remove.png';
import people from '../assets/images/people.png';
import goback from '../assets/images/goback.svg';
import { Button, Container, createTheme, IconButton, ThemeProvider } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { usePrompt } from '../hooks/usePrompt';
import { useTranslatableData } from '../hooks/useTranslatable';
import btnInfo from "../assets/images/icon-info.svg";
import Modal from "react-modal";
import { createEventDedupeKey, pushDataLayerEvent } from "../utils/gtmDataLayer";
import {
  buildEcommerceObject,
  buildItemsFromSelectedServices,
  buildUserDataObject,
  calculateValueFromItems,
} from "../utils/gtmEcommerce";
import { buildGtmEventFields } from "../utils/gtmEventFields";

const customStyles = {
  content: {
    width: "33%",
    top: "50%",
    padding: "40px",
    left: "50%",
    right: "auto",
    bottom: "auto",
    borderRadius: "10px",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
    maxWidth: "450px",
    margin: "auto",
    textAlign: "center",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};

const theme = createTheme({
  palette: {
    white: {
      "main": "#FFFFFF",
      "light": "#FFFFFF",
      "dark": "#FFFFFF",
      "contrastText": "#FFFFFF"
    },
    dark_yellow: {
      "main": "#393D44",
      "light": "#393D44",
      "dark": "#393D44",
      "contrastText": "#FAEF9B",
    },
    dark_white: {
      "main": "#393D44",
      "light": "#393D44",
      "dark": "#393D44",
      "contrastText": "#FFFFFF",
    },
    dark: {
      "main": "#393D44",
      "light": "#393D44",
      "dark": "#393D44",
      "contrastText": "#393D44"
    }
  },
});

const EDIT_STEP_PATHS = [
  '/choose-location',
  '/hotel-choose-service',
  '/hotel-choose-therapist',
  '/hotel-payment'
];

function HotelChooseService() {
  const { t } = useTranslation(['hotel', 'commande_edit']);
  const [categories, setCategories] = useState([]);
  const [domains, setDomains] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const api = useApi();
  const navigate = useNavigate();
  const notify = useNotifications();
  const { auth } = useAuth();
  const loc = useLocation();
  const locState = useLocation().state || {};
  const sessionState = JSON.parse(sessionStorage.getItem('state') || '{}');
  const [modalIsOpenService, setIsOpenService] = useState(false);
  const closeModalservice = () => setIsOpenService(false);
  const openModalservice = () => setIsOpenService(true);
  const [hasModalShown, setHasModalShown] = useState(false);
  const [trackingUser, setTrackingUser] = useState(auth?.user || null);


  const address = locState.address ?? sessionState.address;
  const hotel = locState.hotel ?? sessionState.hotel ?? {};
  const hotelId = hotel.id
    ?? locState.hotelId
    ?? locState.hotel_id
    ?? sessionState.hotelId
    ?? sessionState.hotel_id
    ?? address?.hotel_id
    ?? address?.hotel?.id;
  const duo_capability = (() => {
    if (hotel && typeof hotel.duo_capability === 'boolean') return hotel.duo_capability;
    if (sessionState && typeof sessionState.hotel?.duo_capability === 'boolean') return sessionState.hotel.duo_capability;
    if (hotel && (hotel.duo_capability === '1' || hotel.duo_capability === 1)) return true;
    if (sessionState && (sessionState.hotel?.duo_capability === '1' || sessionState.hotel?.duo_capability === 1)) return true;
    return false;
  })();
  const oldBooking = JSON.parse(sessionStorage.getItem("oldBooking") || "{}");

  const isEdit = sessionStorage.getItem("editBookingMode") === "true";
  const newBooking = isEdit
    ? JSON.parse(sessionStorage.getItem("newBooking") || "{}")
    : null;

  const [services, setServices] = useState([]);
  const [selectedServices, setSelectedServices] = useState(() => {
    // Check if we have selectedServices in sessionStorage (from edit mode)
    const sessionState = JSON.parse(sessionStorage.getItem('state') || '{}');
    const existingServices = sessionState.selectedServices;

    // If we have existing services and we're in edit mode, create service objects for each
    if (existingServices && existingServices.length > 0 && sessionStorage.getItem("editBookingMode") === "true") {
      return existingServices.map((service) => ({
        domain: null,
        category: null,
        subCategory: null,
        product: service.product || service.service, // Pre-select the product
        cat_has_products: false,
        sub_categories: [],
        products: [],
        productsCat: [],
        sub_cat_has_products: false,
        cat_has_subcategories: false,
        showDescriptionForId: null,
        showDescriptionForType: null,
        showProductsForId: null,
        showProductsForType: null,
        showProductsForIdParent: null
      }));
    }

    // Otherwise use default single service
    return [
      {
        domain: null,
        category: null,
        subCategory: null,
        product: null,
        cat_has_products: false,
        sub_categories: [],
        products: [],
        productsCat: [],
        sub_cat_has_products: false,
        cat_has_subcategories: false,
        showDescriptionForId: null,
        showDescriptionForType: null,
        showProductsForId: null,
        showProductsForType: null,
        showProductsForIdParent: null
      }
    ];
  });
  const [duoModalOpenLocal, setDuoModalOpenLocal] = useState(false);
  const isEditMode = sessionStorage.getItem("editBookingMode") === "true";
  const savedOldBooking = JSON.parse(sessionStorage.getItem('oldBooking') || '{}');
  const originallyDuo = savedOldBooking?.isDuo || false;
  const [isActive, setIsActive] = useState(originallyDuo || sessionState?.isDuo || false);
  const latestGlobalState = JSON.parse(sessionStorage.getItem("state") || "{}");

  // Use translated data for instant language switching
  const translatedDomains = useTranslatableData(domains);
  const translatedSelectedServices = useTranslatableData(selectedServices);
  
  const showDuoToggle = isEditMode 
    ? (originallyDuo || (savedOldBooking?.nbpeople >= 2))
    : duo_capability && (selectedServices.length === 2 || selectedServices.length === 4);

  usePrompt(
    isEdit,
    "Êtes-vous sûr de vouloir quitter la modification ? Vos changements ne seront pas enregistrés.",
    next => EDIT_STEP_PATHS.some(p => next.pathname.startsWith(p))
  );

  const { i18n } = useTranslation('hotel');

  useEffect(() => {
    setTrackingUser(auth?.user || null);
  }, [auth?.user]);

  const hasPrimaryAddress = (user) =>
    Boolean(
      user?.primary_address?.id
      || user?.primary_address?.street
      || user?.primary_address?.zip_code
      || user?.primaryAddress?.id
      || user?.primaryAddress?.street
      || user?.primaryAddress?.zip_code
    );

  const resolveTrackingUser = async () => {
    if (!auth?.user?.id) {
      return trackingUser || auth?.user || null;
    }

    const currentUser = trackingUser || auth?.user;
    if (hasPrimaryAddress(currentUser)) {
      return currentUser;
    }

    try {
      const response = await AuthService.me(
        { id: auth.user.id, with: "primary_address" },
        api
      );
      const nextUser = response?.user || currentUser;
      setTrackingUser(nextUser || null);
      return nextUser || currentUser || null;
    } catch (_) {
      return currentUser || null;
    }
  };

  const fetchDomains = async () => {
    try {
      const response = await DomainService.index(
        {
          hotel_id: hotelId,
          is_active: 1,
          with: 'media'
        },
        api,
        auth?.accessToken ? false : true
      );
      setDomains(response);
    } catch (error) {
      console.error("Error fetching domains:", error);
    }
  };

  const fetchCategories = async (domainId) => {
    try {
      const response = await CategoryService.index(
        {
          hotel_id: hotelId,
          domain_id: domainId,
          parent_id: null,
          is_active: 1,
          with: 'media,subcategories'
        },
        api,
        auth?.accessToken ? false : true
      );

      const filteredCategories = response.map(category => ({
        ...category,
        sub_categories: category.subcategories
          ? category.subcategories.filter(sub => !sub.is_hidden)
          : []
      }));

      setCategories(filteredCategories);
      return filteredCategories;
    } catch (error) {
      console.error("Error fetching categories:", error);
      return [];
    }
  };

  const fetchProducts = async (categoryId) => {
    try {
      const response = await ProductService.index(
        {
          hotel_id: hotelId,
          category_id: categoryId,
          is_active: 1,
          is_hidden: false,
          with: 'media,bookings,category'
        },
        api,
        auth?.accessToken ? false : true
      );
      return response;
    } catch (error) {
      console.error("Error fetching products:", error);
      return [];
    }
  };


  const fetchSubCategories = async (categoryId) => {
    try {
      return await CategoryService.index(
        {
          hotel_id: hotelId,
          parent_id: categoryId,
          is_active: 1,
          with: 'media'
        },
        api,
        auth?.accessToken ? false : true
      );
    } catch (error) {
      console.error("Error fetching subcategories:", error);
      return [];
    }
  };

  useEffect(() => {
    fetchDomains();
  }, [hotelId]);

  const guardedToggleSwitch = () => {
    if (isEditMode) {
      if (!isActive && !originallyDuo && (savedOldBooking?.nbpeople < 2)) {
        try { sessionStorage.setItem('pendingDuoToggle', JSON.stringify({ requested: true })); } catch (err) {}
        setDuoModalOpenLocal(true);
        return;
      }
    } else {
      if (!duo_capability && !isActive) {
        openModalservice();
        return;
      }
      // if (!isActive && !originallyDuo) {
      //   try { sessionStorage.setItem('pendingDuoToggle', JSON.stringify({ requested: true })); } catch (err) {}
      //   setDuoModalOpenLocal(true);
      //   return;
      // }
    }
    
    setIsActive(!isActive);
  };

  // Auto-select hierarchy for edit mode
  useEffect(() => {
    const autoSelectHierarchy = async () => {
      if (!isEdit || !domains.length || selectedServices.every(s => s.domain)) return;

      const updatedServices = [...selectedServices];
      let hasChanges = false;

      for (let i = 0; i < selectedServices.length; i++) {
        const service = selectedServices[i];

        // Skip if already has domain or no product
        if (service.domain || !service.product) continue;

        const product = service.product;
        const domainId = product.domain_id;
        const productCategory = product.category;

        // Find the domain
        const domain = domains.find(d => d.id === domainId);
        if (!domain) continue;

        // Set domain and fetch categories
        updatedServices[i].domain = domain;
        const categories = await fetchCategories(domainId);
        updatedServices[i].categories = categories;

        // Check if the product's category is a top-level category or subcategory
        if (productCategory.parent_id === null) {
          // It's a top-level category
          const category = categories.find(c => c.id === productCategory.id);
          if (category) {
            updatedServices[i].category = category;

            // Fetch products and subcategories for this category
            const [products, subcats] = await Promise.all([
              fetchProducts(productCategory.id),
              fetchSubCategories(productCategory.id)
            ]);

            updatedServices[i].products = products;
            updatedServices[i].sub_categories = subcats;
            updatedServices[i].cat_has_products = products.length > 0;
            updatedServices[i].cat_has_subcategories = subcats.length > 0;
            updatedServices[i].showProductsForType = "category";
            updatedServices[i].showProductsForId = productCategory.id;
            updatedServices[i].showProductsForIdParent = null;
          }
        } else {
          // It's a subcategory - find the parent category first
          const parentCategory = categories.find(c => c.id === productCategory.parent_id);
          if (parentCategory) {
            updatedServices[i].category = parentCategory;

            // Fetch products and subcategories for the parent category
            const [products, subcats] = await Promise.all([
              fetchProducts(parentCategory.id),
              fetchSubCategories(parentCategory.id)
            ]);

            updatedServices[i].products = products;
            updatedServices[i].sub_categories = subcats;
            updatedServices[i].cat_has_products = products.length > 0;
            updatedServices[i].cat_has_subcategories = subcats.length > 0;

            // Now find and select the subcategory
            const subcategory = subcats.find(sc => sc.id === productCategory.id);
            if (subcategory) {
              updatedServices[i].subCategory = subcategory;

              // Fetch products for the subcategory
              const [subProducts, subProductsCat] = await Promise.all([
                fetchProducts(productCategory.id),
                fetchProducts(parentCategory.id)
              ]);

              updatedServices[i].products = subProducts;
              updatedServices[i].productsCat = subProductsCat;
              updatedServices[i].sub_cat_has_products = subProducts.length > 0;
              updatedServices[i].showProductsForType = "subCategory";
              updatedServices[i].showProductsForId = productCategory.id;
              updatedServices[i].showProductsForIdParent = parentCategory.id;
            }
          }
        }

        hasChanges = true;
      }

      if (hasChanges) {
        setSelectedServices(updatedServices);
      }
    };

    autoSelectHierarchy();
  }, [domains, isEdit]);

  const handleDomainSelect = async (personIndex, domainObj) => {
    const updated = [...selectedServices];
    const currentlySelected = updated[personIndex].domain?.id === domainObj.id;

    if (currentlySelected) {
      updated[personIndex] = {
        ...updated[personIndex],
        domain: null,
        category: null,
        subCategory: null,
        product: null,
        categories: [],
        sub_categories: [],
        products: [],
        cat_has_products: false,
        sub_cat_has_products: false,
        cat_has_subcategories: false,
        showDescriptionForId: null,
        showDescriptionForType: null,
        showProductsForId: null,
        showProductsForType: null
      };
      setSelectedServices(updated);
      return;
    }

    updated[personIndex].domain = domainObj;
    updated[personIndex].category = null;
    updated[personIndex].subCategory = null;
    updated[personIndex].product = null;
    updated[personIndex].showDescriptionForId = null;
    updated[personIndex].showDescriptionForType = null;

    // Fetch categories for this domain
    const categories = await fetchCategories(domainObj.id);

    updated[personIndex] = {
      ...updated[personIndex],
      categories: categories,
    };

    setSelectedServices(updated);
  };

  const handleCategorySelect = async (personIndex, categoryObj) => {
    const updated = [...selectedServices];
    const currentlySelected = updated[personIndex].category?.id === categoryObj.id;

    if (currentlySelected) {
      updated[personIndex] = {
        ...updated[personIndex],
        category: null,
        subCategory: null,
        product: null,
        sub_categories: [],
        products: [],
        cat_has_products: false,
        sub_cat_has_products: false,
        cat_has_subcategories: false,
        showDescriptionForId: null,
        showDescriptionForType: null,
        showProductsForId: null,
        showProductsForType: null
      };
      setSelectedServices(updated);
      return;
    }

    updated[personIndex].category = categoryObj;
    updated[personIndex].subCategory = null;
    updated[personIndex].product = null;
    updated[personIndex].showDescriptionForId = null;
    updated[personIndex].showDescriptionForType = null;

    const [products, subcats] = await Promise.all([
      fetchProducts(categoryObj.id),
      fetchSubCategories(categoryObj.id)
    ]);

    updated[personIndex] = {
      ...updated[personIndex],
      products: products,
      sub_categories: subcats,
      cat_has_products: products.length > 0,
      cat_has_subcategories: subcats.length > 0,
      showProductsForType: "category",
      showProductsForId: categoryObj.id,
      showProductsForIdParent: null
    };

    setSelectedServices(updated);
  };

  const handleSubCategorySelect = async (personIndex, subcatObj) => {
    const updated = [...selectedServices];
    const currentlySelected = updated[personIndex].subCategory?.id === subcatObj.id;

    if (currentlySelected) {
      updated[personIndex] = {
        ...updated[personIndex],
        subCategory: null,
        product: null,
        products: [],
        sub_cat_has_products: false,
        showDescriptionForId: null,
        showDescriptionForType: null,
        showProductsForId: null,
        showProductsForType: null
      };
      setSelectedServices(updated);
      return;
    }

    updated[personIndex].subCategory = subcatObj;
    updated[personIndex].product = null;
    updated[personIndex].showDescriptionForId = null;
    updated[personIndex].showDescriptionForType = null;

    const [products, productsCat] = await Promise.all([
      fetchProducts(subcatObj.id),
      fetchProducts(updated[personIndex].category.id)
    ]);

    updated[personIndex] = {
      ...updated[personIndex],
      products: products,
      productsCat: productsCat,
      sub_cat_has_products: products.length > 0,
      showProductsForType: "subCategory",
      showProductsForId: subcatObj.id,
      showProductsForIdParent: subcatObj.parent_id
    };

    setSelectedServices(updated);
  };

  const handleProductSelect = (personIndex, prodObj) => {
    const updated = [...selectedServices];
    updated[personIndex].product = prodObj;
    setSelectedServices(updated);
  };

  const toggleDescription = (type, id, personIndex) => {
    const updated = [...selectedServices];
    const currentlySelected = updated[personIndex].showDescriptionForId === id;

    if (currentlySelected) {
      updated[personIndex].showDescriptionForId = null;
      updated[personIndex].showDescriptionForType = null;
    } else {
      updated[personIndex].showDescriptionForId = id;
      updated[personIndex].showDescriptionForType = type;
    }

    setSelectedServices(updated);
  };

  const handleGoBackClick = (personIndex) => {
    const updated = [...selectedServices];
    const current = updated[personIndex];

    if (current.subCategory) {
      current.subCategory = null;
      current.product = null;
      current.products = [];
      current.showProductsForId = current.category.id;
      current.showProductsForType = "category";
    } else if (current.category) {
      current.category = null;
      current.subCategory = null;
      current.product = null;
      current.sub_categories = [];
      current.products = [];
      current.showProductsForId = null;
      current.showProductsForType = null;
    } else if (current.domain) {
      current.domain = null;
      current.category = null;
      current.subCategory = null;
      current.product = null;
      current.sub_categories = [];
      current.products = [];
      current.categories = [];
      current.showProductsForId = null;
    }
    setSelectedServices(updated);
  };

  const addPerson = () => {
    if (selectedServices.length < 4) {
      setSelectedServices([
        ...selectedServices,
        {
          category: null,
          subCategory: null,
          product: null,
          cat_has_products: false,
          sub_categories: [],
          products: [],
          sub_cat_has_products: false,
          cat_has_subcategories: false,
          showDescriptionForId: null,
          showDescriptionForType: null,
          showProductsForId: null,
          showProductsForType: null
        }
      ]);
    }
  };

  const removePerson = (index) => {
    setSelectedServices(selectedServices.filter((_, i) => i !== index));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (selectedServices.some(s => !s.product)) {
      return notify.warn(t('please_select_a_product'));
    }

    const prev = JSON.parse(sessionStorage.getItem('state') || '{}');
    const duoFlag = (selectedServices.length === 2 || selectedServices.length === 4) && isActive;

    const stateToSave = {
      ...prev,
      hotel,
      hotelId,
      hotel_id: hotelId,
      duo_capability,
      address,
      selectedServices: selectedServices.map(s => ({
        // store a human-readable label for UI while keeping the full product object
        service: (s.product && (s.product.title || s.product.name)) || null,
        product: s.product,
        productId: s.product?.id
      })),
      duo: duoFlag
    };

    sessionStorage.setItem('state', JSON.stringify(stateToSave));
    sessionStorage.setItem('address', JSON.stringify(address));

    const trackAddToCart = async () => {
      try {
        const resolvedTrackingUser = await resolveTrackingUser();
        const items = buildItemsFromSelectedServices(selectedServices, {
          address,
          hotelId,
        });
        const trackingUserData = buildUserDataObject({
          user: resolvedTrackingUser,
          address,
          phoneNumber: latestGlobalState?.phone || resolvedTrackingUser?.phone || auth?.user?.phone,
          emailAddress: resolvedTrackingUser?.email || auth?.user?.email,
          isConnectedUser: Boolean(auth?.user?.id),
        });
        if (items.length > 0) {
          const value = calculateValueFromItems(items);
          const itemsSignature = items.map((item) => item.item_id).join(",");
          pushDataLayerEvent(
            "add_to_cart",
            {
              user_data: trackingUserData,
              ...buildGtmEventFields({
                language: i18n.language,
                user: resolvedTrackingUser || auth?.user,
              }),
              ecommerce: buildEcommerceObject({
                currency: "CHF",
                value,
                items,
              }),
            },
            {
              dedupeKey: createEventDedupeKey(
                "add_to_cart",
                itemsSignature,
                hotelId,
                address?.zip_code,
                selectedServices.length
              ),
              dedupeTtlMs: 30000,
            }
          );
        }
      } catch (trackingError) {
        console.error("Failed to push add_to_cart event:", trackingError);
      }
    };

    if (isEdit) {
      const updatedBooking = {
        ...stateToSave,
        products: selectedServices.map(s => s.product),
        product: selectedServices[0].product,
        duo_capability: duo_capability,
        isDuo: duo_capability && duoFlag
      };

      sessionStorage.setItem('newBooking', JSON.stringify(updatedBooking));
      sessionStorage.setItem('editBookingMode', 'true');

      await trackAddToCart();
      navigate('/hotel-choose-therapist', {
        state: { fromEditBooking: true, ...updatedBooking }
      });
      return;
    }
    // Diagnostic: log duo state to help debug why modal content may not match expectation
    console.log('submit debug', { duo_capability, isActive, selectedCount: selectedServices.length });

    if (
      (selectedServices.length === 2 || selectedServices.length === 4) &&
      !hasModalShown &&
      (
        (duo_capability && !isActive) ||
        !duo_capability
      )
    ) {
      openModalservice();
      setHasModalShown(true);
      return false;
    }

    await trackAddToCart();
    navigate('/hotel-choose-therapist', { state: stateToSave, address: address });
  };

  return (
    <>
      {console.log('HOTEL DEBUG', { 
        hotel, hotelId, duo_capability, selectedServices, 
        isEditMode, originallyDuo, savedOldBooking_nbpeople: savedOldBooking?.nbpeople,
        showDuoToggle, isActive 
      })}
      <MenuHeader />
      <NavHotel page="service" />
      <div className={`container container-location container-service booking-service-page booking-service-page--hotel row-${selectedServices.length}`}>
        {(translatedSelectedServices[0].domain || translatedSelectedServices[0].category) && selectedServices.length === 1 ? (
          <Container className="booking-service-page__title-row" sx={{ display: 'flex', padding: '10px 0 !important' }}>
            <ThemeProvider theme={theme}>
              <Button
                variant="outlined"
                onClick={() => handleGoBackClick(0)}
                color='dark'
                type="button"
                sx={{ textTransform: 'none', borderRadius: '15px', width: '100%', maxWidth: '50px', minHeight: '40px' }}
              >
                <img className="https-app" src={goback} alt="Back" />
              </Button>
            </ThemeProvider>
            <h2 className='h-goback'>{t('choose_service_type')}</h2>
          </Container>
        ) : (
          <h2>
            {selectedServices.length > 1
              ? t('choose_service_type_plus')
              : t('choose_service_type')}
          </h2>
        )}

        <form className="service-form booking-service-page__form" onSubmit={handleSubmit}>
          <div className='content-row'>
            {translatedSelectedServices.map((person, idx) => (
              <div key={idx} className="person-services">
                {selectedServices.length > 1 && (
                  <h3 className='person-title'>
                    <span>
                      {(person.domain || person.category) && (
                        <img
                          className="https-app"
                          src={goback}
                          alt="Back"
                          onClick={() => handleGoBackClick(idx)}
                        />
                      )}
                      <img className='people' src={people} alt="Person" />
                      {idx === 0 ? t('me') : `${t('guest')} ${idx}`}
                    </span>
                    {idx > 0 && (
                      <button
                        type='button'
                        className='person-remove'
                        onClick={() => removePerson(idx)}
                      >
                        <img className='remove' src={remove} alt="Remove" />
                      </button>
                    )}
                  </h3>
                )}

                {/* Domains */}
                {!person.domain && (
                  <div className="services-container">
                    {translatedDomains.map(dom => {
                      const isSelected = person.domain?.id === dom.id;
                      const hasDescription = typeof dom.description === 'string' && dom.description.trim() !== '';
                      return (
                        <div key={dom.id} className="service-wrapper">
                          <div
                            className={`service-card ${isSelected ? 'selected' : ''}`}
                            style={{
                              background: `linear-gradient(135deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.4)), url(${dom?.media[0]?.original_url}) no-repeat center center / cover`,
                            }}
                          >
                            <div className="service-info">
                              <div className="service-text">
                                <h3>{dom.title}</h3>
                                {dom.description !== null && dom.description !== '' && hasDescription && (
                                  <ThemeProvider theme={theme}>
                                    <Button
                                      variant="text"
                                      color='white'
                                      onClick={() => toggleDescription("domain", dom.id, idx)}
                                      sx={{ opacity: 0.7, gap: '5px', padding: 0 }}
                                    >
                                      {t('more_info')} <img src="assets/images/icon-expand.svg" alt="Expand" />
                                    </Button>
                                  </ThemeProvider>
                                )}
                              </div>
                              {isSelected ? (
                                <IconButton onClick={() => handleDomainSelect(idx, dom)}>
                                  <img src='assets/images/check.png' height={20} width={20} alt="Selected" />
                                </IconButton>
                              ) : (
                                <ThemeProvider theme={theme}>
                                  <Button
                                    variant="outlined"
                                    color='white'
                                    onClick={() => handleDomainSelect(idx, dom)}
                                    sx={{ borderRadius: '15px' }}
                                  >
                                    {t('select')}
                                  </Button>
                                </ThemeProvider>
                              )}
                            </div>
                          </div>
                          {person.showDescriptionForType === "domain" &&
                            person.showDescriptionForId === dom.id &&
                            <div className="service-description">{dom.description}</div>
                          }
                        </div>
                      );
                    })}
                  </div>
                )}

                {/* Categories */}
                {person.domain && person.categories?.length > 0 && person.categories.map(cat => {
                  const isSelected = person.category?.id === cat.id;
                  const hasDescription = typeof cat.description === 'string' && cat.description.trim() !== '';
                  return person.domain && (!person.category || (person.category && !person.sub_categories.length) ||
                    (person.category && person.cat_has_products &&
                      (!person.cat_has_subcategories || (person.cat_has_subcategories && person.category.id === cat.id)))) && (
                      <div className="services-container">

                        <div key={cat.id} className="service-wrapper">
                          <div
                            className={`service-card ${isSelected ? 'selected' : ''}`}
                            style={{
                              background: `linear-gradient(135deg, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.5)), url(${cat?.media[0]?.original_url}) no-repeat center center / cover`,
                            }}
                          >
                            <div className="service-info">
                              <div className="service-text">
                                <h3>{cat.title}</h3>
                                {cat.description !== null && cat.description !== '' && hasDescription && (
                                  <ThemeProvider theme={theme}>
                                    <Button
                                      variant="text"
                                      color='white'
                                      onClick={() => toggleDescription("category", cat.id, idx)}
                                      sx={{ opacity: 0.7, gap: '5px', padding: 0 }}
                                    >
                                      {t('more_info')} <img src="assets/images/icon-expand.svg" alt="Expand" />
                                    </Button>
                                  </ThemeProvider>
                                )}
                              </div>
                              {isSelected ? (
                                <IconButton onClick={() => handleCategorySelect(idx, cat)}>
                                  <img src='assets/images/check.png' height={20} width={20} alt="Selected" />
                                </IconButton>
                              ) : (
                                <ThemeProvider theme={theme}>
                                  <Button
                                    variant="outlined"
                                    color='white'
                                    onClick={() => handleCategorySelect(idx, cat)}
                                    sx={{ borderRadius: '15px' }}
                                  >
                                    {t('select')}
                                  </Button>
                                </ThemeProvider>
                              )}
                            </div>
                          </div>
                          {person.showDescriptionForType === "category" &&
                            person.showDescriptionForId === cat.id &&
                            <div className="service-description">{cat.description}</div>
                          }

                          {/* Products for category */}
                          {person.showProductsForType === "category" && person.showProductsForId === cat.id && (
                            <div className='form-duree yoo'>
                              <div className="form-group serv-form">
                                <div
                                  className={`btn-group group-3 ${person.products?.length > 2 ? 'service-product-group--compact' : ''}`}
                                  role="group"
                                  style={{ '--service-product-count': Math.max(person.products?.length || 1, 1) }}
                                >
                                  {person.products.map(product => (
                                    <button
                                      type="button"
                                      key={product.id}
                                      className={`btn-default ${person.product?.id === product.id ? 'btn-checked' : ''}`}
                                      onClick={() => handleProductSelect(idx, product)}
                                    >
                                      <span>{product.duration} min</span>
                                      <br />
                                      <span className="price">{product.price} chf</span>
                                    </button>
                                  ))}
                                </div>
                              </div>
                            </div>
                          )}

                          {/* Products for parent category when subcategory is selected */}
                          {isSelected && person.showProductsForIdParent === cat.id && (
                            <div className='form-duree'>
                              <div className="form-group serv-form">
                                <div
                                  className={`btn-group group-3 ${person.productsCat?.length > 2 ? 'service-product-group--compact' : ''}`}
                                  role="group"
                                  style={{ '--service-product-count': Math.max(person.productsCat?.length || 1, 1) }}
                                >
                                  {person.productsCat?.map(product => (
                                    <button
                                      type="button"
                                      key={product.id}
                                      className={`btn-default ${person.product?.id === product.id ? 'btn-checked' : ''}`}
                                      onClick={() => handleProductSelect(idx, product)}
                                    >
                                      <span>{product.duration} min</span>
                                      <br />
                                      <span className="price">{product.price} chf</span>
                                    </button>
                                  ))}
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    );
                })}

                {/* Subcategories */}
                {person.domain && person.category && person.sub_categories.length > 0 &&
                  (!person.subCategory || (person.subCategory && !person.products.length) ||
                    (person.subCategory && person.sub_cat_has_products)) && (
                    <div className="services-container">
                      {person.sub_categories.map(sc => {
                        const isSelected = person.subCategory?.id === sc.id;
                        const hasDescription = typeof sc.description === 'string' && sc.description.trim() !== '';
                        return (
                          <div key={sc.id} className="service-wrapper">
                            <div
                              className={`service-card ${isSelected ? 'selected' : ''}`}
                              style={{
                                background: `linear-gradient(135deg, rgba(0,0,0,0.8), rgba(0,0,0,0.5)), url(${sc?.media[0]?.original_url}) center/cover no-repeat`
                              }}
                            >
                              <div className="service-info">
                                <div className="service-text">
                                  <h3>{sc.title}</h3>
                                  {sc.description !== null && sc.description !== '' && hasDescription && (
                                    <ThemeProvider theme={theme}>
                                      <Button
                                        variant="text"
                                        color='white'
                                        onClick={() => toggleDescription("subCategory", sc.id, idx)}
                                        sx={{ opacity: 0.7, gap: '5px', padding: 0 }}
                                      >
                                        {t('more_info')} <img src="assets/images/icon-expand.svg" alt="Expand" />
                                      </Button>
                                    </ThemeProvider>
                                  )}
                                </div>
                                {isSelected ? (
                                  <IconButton onClick={() => handleSubCategorySelect(idx, sc)}>
                                    <img src='assets/images/check.png' height={20} width={20} alt="Selected" />
                                  </IconButton>
                                ) : (
                                  <ThemeProvider theme={theme}>
                                    <Button
                                      variant="outlined"
                                      color='white'
                                      onClick={() => handleSubCategorySelect(idx, sc)}
                                      sx={{ borderRadius: '15px' }}
                                    >
                                      {t('select')}
                                    </Button>
                                  </ThemeProvider>
                                )}
                              </div>
                            </div>
                            {person.showDescriptionForType === "subCategory" &&
                              person.showDescriptionForId === sc.id &&
                              <div className="service-description">{sc.description}</div>
                            }

                            {/* Products for subcategory */}
                            {person.showProductsForType === "subCategory" && person.showProductsForId === sc.id && (
                              <div className='form-duree'>
                                <div className="form-group serv-form">
                                  <div
                                    className={`btn-group group-3 ${person.products?.length > 2 ? 'service-product-group--compact' : ''}`}
                                    role="group"
                                    style={{ '--service-product-count': Math.max(person.products?.length || 1, 1) }}
                                  >
                                    {person.products.map(product => (
                                      <button
                                        type="button"
                                        key={product.id}
                                        className={`btn-default ${person.product?.id === product.id ? 'btn-checked' : ''}`}
                                        onClick={() => handleProductSelect(idx, product)}
                                      >
                                        <span>{product.duration} min</span>
                                        <br />
                                        <span className="price">{product.price} chf</span>
                                      </button>
                                    ))}
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  )}
              </div>
            ))}
          </div>

          {showDuoToggle && (
            <div className='btn-grp'>
              <div className='duo'>
                <div className='info'>
                  {t('duo_massage')} <i className="fa fa-info-circle"></i>
                </div>
                <div className='toggle'>
                  <div
                    className={`toggle-switch ${isActive ? 'active' : ''}`}
                    onClick={guardedToggleSwitch}
                  ></div>
                </div>
              </div>
            </div>
          )}

          <Container className="booking-service-page__actions" sx={{ display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap', padding: '0 !important' }}>
            <ThemeProvider theme={theme}>
              <Button
                className="booking-service-page__action-button booking-service-page__add-treatment-button"
                variant="outlined"
                color='dark'
                type="button"
                onClick={addPerson}
                sx={{ textTransform: 'none', borderRadius: '15px', width: '100%', maxWidth: '315px', minHeight: '57px' }}
              >
                {t('add_person')}
              </Button>

              <Button
                className="booking-service-page__action-button"
                variant="contained"
                color='dark_yellow'
                type="submit"
                sx={{ textTransform: 'none', borderRadius: '15px', width: '100%', maxWidth: '315px', minHeight: '57px' }}
              >
                {t('next')}
              </Button>
            </ThemeProvider>
          </Container>
        </form>
      </div>
      <Modal
        isOpen={modalIsOpenService}
        onRequestClose={closeModalservice}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <div className="zone-not-served-container">
          <div className="popup-box">
            <button onClick={closeModalservice} className="close-btn"><img src={btnInfo} alt="Fermer" /></button>
            <p>
              {!duo_capability ? (
                i18n.language && i18n.language.startsWith('fr')
                  ? "Ce spa ne propose pas de soins en duo. Les soins seront effectués à la suite avec un(e) seul(e) flypro."
                  : "This spa does not offer duo treatments. Services will be provided back-to-back with a single flypro."
              ) : duo_capability && !isActive ? (
                t('modal_message')
              ) : (
                i18n.language && i18n.language.startsWith('fr')
                  ? "Pour votre information, il s'agit de soins à la suite avec un(e) seul(e) flypro."
                  : "For your information, these are back-to-back treatments with a single flypro."
              )}
            </p>
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={duoModalOpenLocal}
        onRequestClose={() => { setDuoModalOpenLocal(false); try { sessionStorage.removeItem('pendingDuoToggle'); } catch (err) {} }}
        style={customStyles}
      >
        <h2>{t('commande_edit:sorry', { ns: 'commande_edit' })}</h2>
        <p>
          {t('commande_edit:duo_massage_disclaimer', { ns: 'commande_edit' })}
          <br /><br />
          {t('commande_edit:duo_massage_disclaimer2', { ns: 'commande_edit' })}
        </p>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', marginTop: 18 }}>
          <button className="btn btn-secondary" onClick={() => { setDuoModalOpenLocal(false); try { sessionStorage.removeItem('pendingDuoToggle'); } catch (err) {} }}>
            {t('commande_edit:close', { ns: 'commande_edit' })}
          </button>
          <button className="btn btn-primary" onClick={() => { try { sessionStorage.removeItem('pendingDuoToggle'); } catch (err) {} setDuoModalOpenLocal(false); navigate('/'); }}>
            {t('commande_edit:duo_booking', { ns: 'commande_edit' })}
          </button>
        </div>
      </Modal>
    </>
  );
}

export default HotelChooseService;
